import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

// eslint-disable-next-line no-unused-vars
export const swiperTop = (swiperClass, slidesPerView, spaceBetween) => {
  const swiper = new Swiper(swiperClass, {
    modules: [Navigation, Autoplay],
    init: false,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView,
        spaceBetween,
      },
    },
  });
  swiper.on("afterInit", () => {
    swiper.slideTo(1, 500, false);
  });
  swiper.init();
};

export default swiperTop;
